export default "__VITE_ASSET__CbAiEYBu__"